import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_CATEGORY_LISTING,
    ADD_CATEGORY,
    UPDATE_CATEGORY,
    BULK_UPDATE_CATEGORY,
    DELETE_CATEGORY,
    BULK_DELETE_CATEGORY,
    EXPORT_CATEGORY,
    GET_CATEGORY_DETAILS,
} from "./actionTypes.js";

import {
    getCategoryListingSuccess,
    getCategoryListingFail,
    getCategoryDetailsSuccess,
    createCategorySuccess,
    createCategoryFail,
    updateCategorySuccess,
    updateCategoryFail,
    bulkUpdateCategorySuccess,
    bulkUpdateCategoryFail,
    deleteCategorySuccess,
    deleteCategoryFail,
    bulkDeleteCategorySuccess,
    bulkDeleteCategoryFail,
    exportCategorySuccess,
    exportCategoryFail,
    getCategoryDetailsFail,
} from "./actions.js";

import {
    categoryListingApi,
    categoryDetailsApi,
    addCategoryApi,
    updateCategoryApi,
    bulkUpdateCategoryApi,
    deleteCategoryApi,
    bulkDeleteCategoryApi,
    exportCategoryApi,
} from "./categoryApi.js";

function* fetchCategoryListing({ payload }) {
    try {
        const response = yield call(categoryListingApi, payload);
        yield put(getCategoryListingSuccess(response));
    } catch (error) {
        yield put(getCategoryListingFail(error));
    }
}

function* fetchCategoryDetail({ payload }) {
    try {
        const response = yield call(categoryDetailsApi, payload);
        yield put(getCategoryDetailsSuccess(response));
    } catch (error) {
        yield put(getCategoryDetailsFail(error));
    }
}

function* createCategory({ payload }) {
    try {
        const response = yield call(addCategoryApi, payload);
        yield put(createCategorySuccess(response));
    } catch (error) {
        yield put(createCategoryFail(error));
    }
}

function* updateCategory({ payload }) {
    try {
        const response = yield call(updateCategoryApi, payload);
        yield put(updateCategorySuccess(response));
    } catch (error) {
        yield put(updateCategoryFail(error));
    }
}

function* bulkUpdateCategory({ payload }) {
    try {
        const response = yield call(bulkUpdateCategoryApi, payload);
        yield put(bulkUpdateCategorySuccess(response));
    } catch (error) {
        yield put(bulkUpdateCategoryFail(error));
    }
}

function* deleteCategory({ payload }) {
    try {
        const response = yield call(deleteCategoryApi, payload);
        yield put(deleteCategorySuccess(response));
    } catch (error) {
        yield put(deleteCategoryFail(error));
    }
}

function* bulkDeleteCategory({ payload }) {
    try {
        const response = yield call(bulkDeleteCategoryApi, payload);
        yield put(bulkDeleteCategorySuccess(response));
    } catch (error) {
        yield put(bulkDeleteCategoryFail(error));
    }
}

function* exportCategory({ payload }) {
    try {
        const response = yield call(exportCategoryApi, payload);
        yield put(exportCategorySuccess(response));
    } catch (error) {
        yield put(exportCategoryFail(error));
    }
}

function* CategorySaga() {
    yield takeEvery(GET_CATEGORY_LISTING, fetchCategoryListing);
    yield takeEvery(GET_CATEGORY_DETAILS, fetchCategoryDetail);
    yield takeEvery(ADD_CATEGORY, createCategory);
    yield takeEvery(UPDATE_CATEGORY, updateCategory);
    yield takeEvery(BULK_UPDATE_CATEGORY, bulkUpdateCategory);
    yield takeEvery(DELETE_CATEGORY, deleteCategory);
    yield takeEvery(BULK_DELETE_CATEGORY, bulkDeleteCategory);
    yield takeEvery(EXPORT_CATEGORY, exportCategory);

}

export default CategorySaga
